import { React, useLayoutEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { Button, Row, Col, Input, Collapse, Avatar, Form } from "antd";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Controller } from "swiper";
import heroImage from "../../../assets/images/cover-images/heroImage.png";
import featureimgOne from "../../../assets/images/cover-images/feature-imgOne.png";
import featureimgTwo from "../../../assets/images/cover-images/feature-imgTwo.png";
import featureimgThree from "../../../assets/images/cover-images/feature-imgThree.png";
import doctorImage from "../../../assets/images/cover-images/doctorImage.png";
import clientOne from "../../../assets/images/logos/clientOne.png";
import clientTwo from "../../../assets/images/logos/clientTwo.png";
import clientThree from "../../../assets/images/logos/clientThree.png";
import clientFour from "../../../assets/images/logos/clientFour.png";
import clientFive from "../../../assets/images/logos/clientSeven.png";
import clientSix from "../../../assets/images/logos/clientFive.png";
import clientSeven from "../../../assets/images/logos/clientSix.png";
import { SVGicon } from "../../../styleGuide/SVGicon/SVGicon";
import "swiper/css";
import "./Home.css";

/* eslint-disable no-template-curly-in-string */
const validateMessages = {
     required: '${label} is required!',
     types: {
          email: '${label} is not a valid email!',
     },
};
/* eslint-enable no-template-curly-in-string */


const { Panel } = Collapse;


const ReviewTextOne = [
     { userAvatar: "https://i.pravatar.cc/150?img=3", userInitial: "C", userRate: 4, userName: "Cameron Williamson", userPlace: "New York, USA", userReview: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Elit sed vulputate Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua." },
     { userAvatar: "https://i.pravatar.cc/150?img=3", userInitial: "D", userRate: 3, userName: "Darrell Steward", userPlace: "New York, USA", userReview: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliquaElit sed vulputate Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua." },
     { userAvatar: "https://i.pravatar.cc/150?img=3", userInitial: "D", userRate: 2, userName: "Dianne Russell", userPlace: "New York, USA", userReview: "“Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna a sed vulputate.Elit sed vulputate Lorem ipsum dolor sit amet. ”" },
     { userAvatar: "https://i.pravatar.cc/150?img=3", userInitial: "C", userRate: 4, userName: "Cameron Williamson", userPlace: "New York, USA", userReview: "“Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Elit sed vulputate Lorem ipsum dolor sit amet. ”" },
     { userAvatar: "https://i.pravatar.cc/150?img=3", userInitial: "D", userRate: 3, userName: "Darrell Steward", userPlace: "New York, USA", userReview: "“Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt. consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Elit sed vulputate.”" },
     { userAvatar: "https://i.pravatar.cc/150?img=3", userInitial: "D", userRate: 2, userName: "Dianne Russell", userPlace: "New York, USA", userReview: "“Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Elit sed vulputate.Elit sed vulputate Lorem ipsum dolor sit amet. ”" },
     { userAvatar: "https://i.pravatar.cc/150?img=3", userInitial: "C", userRate: 4, userName: "Cameron Williamson", userPlace: "New York, USA", userReview: "“Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Elit sed vulputate Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.”" },
     { userAvatar: "https://i.pravatar.cc/150?img=3", userInitial: "C", userRate: 3, userName: "Darrell Steward", userPlace: "New York, USA", userReview: "“Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.Elit sed vulputate Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.”" },
     { userAvatar: "https://i.pravatar.cc/150?img=3", userInitial: "D", userRate: 2, userName: "Dianne Russell", userPlace: "New York, USA", userReview: "“Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Elit sed vulputate.Elit sed vulputate Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor. ”" },
     { userAvatar: "https://i.pravatar.cc/150?img=3", userInitial: "D", userRate: 2, userName: "Dianne Russell", userPlace: "New York, USA", userReview: "“Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt. Elit sed vulputate Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.”" },
]
const ReviewTextTwo = [
     { userAvatar: "https://i.pravatar.cc/150?img=3", userInitial: "A", userRate: 4, userName: "Arlene McCoy", userPlace: "New York, USA", userReview: "“Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ”" },
     { userAvatar: "https://i.pravatar.cc/150?img=3", userInitial: "S", userRate: 3, userName: "Savannah Nguyen", userPlace: "New York, USA", userReview: "“Lorem ipsum dolor sit amet, consectetur adipiscing elit, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. sed do eiusmod tempor incididunt.”" },
     { userAvatar: "https://i.pravatar.cc/150?img=3", userInitial: "A", userRate: 2, userName: "Albert Flores", userPlace: "New York, USA", userReview: "“Lorem ipsum dolor sit amet, consectetur adipiscing elit,  consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Elit sed vulputate. ”" },
     { userAvatar: "https://i.pravatar.cc/150?img=3", userInitial: "A", userRate: 4, userName: "Arlene McCoy", userPlace: "New York, USA", userReview: "“Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Elit sed vulputate Lorem ipsum dolor sit amet. ”" },
     { userAvatar: "https://i.pravatar.cc/150?img=3", userInitial: "S", userRate: 3, userName: "Savannah Nguyen", userPlace: "New York, USA", userReview: "“Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt. consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Elit sed vulputate.”" },
     { userAvatar: "https://i.pravatar.cc/150?img=3", userInitial: "A", userRate: 2, userName: "Albert Flores", userPlace: "New York, USA", userReview: "“Lorem ipsum dolor sit amet, consectetur adipiscing elit,  consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Elit sed vulputate. ”" },
     { userAvatar: "https://i.pravatar.cc/150?img=3", userInitial: "A", userRate: 4, userName: "Arlene McCoy", userPlace: "New York, USA", userReview: "“Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Elit sed vulputate Lorem ipsum dolor sit amet, consectetur adipiscing elit.”" },
     { userAvatar: "https://i.pravatar.cc/150?img=3", userInitial: "S", userRate: 3, userName: "Savannah Nguyen", userPlace: "New York, USA", userReview: "“Lorem ipsum dolor sit amet, consectetur adipiscing elit,  consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. sed do eiusmod tempor incididunt.”" },
     { userAvatar: "https://i.pravatar.cc/150?img=3", userInitial: "A", userRate: 2, userName: "Albert Flores", userPlace: "New York, USA", userReview: "“Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Elit sed vulputate. ”" },
]
const OrganizationBlog = [
     {
          organizationBlogImage: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
          organizationBlogTitle: "Employer Branding 101: Why, How and Proven ROI",
          organizationBlogText: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore."
     },
     {
          organizationBlogImage: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
          organizationBlogTitle: "Templates for Hiring Pros: How to Respond to Reviews",
          organizationBlogText: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore."
     },
     {
          organizationBlogImage: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
          organizationBlogTitle: "Metropolis Employer Center Guide",
          organizationBlogText: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore."
     },
]

const HomeFAQ = [
     {
          faqQuestion: "What is Metropolis?",
          faqAnswer: "Metropolis helps organization looking to hire doctors to easily connect to active candidates from the Metropolis network of 40,000 UK-based doctors. We bridge the gap between expensive locum agencies and DIY solutions like Indeed and LinkedIn that distract your team.",
     },
     {
          faqQuestion: "How does it work?",
          faqAnswer: "Metropolis helps organization looking to hire doctors to easily connect to active candidates from the Metropolis network of 40,000 UK-based doctors. We bridge the gap between expensive locum agencies and DIY solutions like Indeed and LinkedIn that distract your team.",
     },
     {
          faqQuestion: "Who is Metropolis for?",
          faqAnswer: "Metropolis helps organization looking to hire doctors to easily connect to active candidates from the Metropolis network of 40,000 UK-based doctors. We bridge the gap between expensive locum agencies and DIY solutions like Indeed and LinkedIn that distract your team.",
     },
     {
          faqQuestion: "What kinds of doctors are on Metropolis?",
          faqAnswer: "Metropolis helps organization looking to hire doctors to easily connect to active candidates from the Metropolis network of 40,000 UK-based doctors. We bridge the gap between expensive locum agencies and DIY solutions like Indeed and LinkedIn that distract your team.",
     },
     {
          faqQuestion: "What is the vetting process for doctors?",
          faqAnswer: "Metropolis helps organization looking to hire doctors to easily connect to active candidates from the Metropolis network of 40,000 UK-based doctors. We bridge the gap between expensive locum agencies and DIY solutions like Indeed and LinkedIn that distract your team.",
     },
     {
          faqQuestion: "How much does it cost?",
          faqAnswer: "Metropolis helps organization looking to hire doctors to easily connect to active candidates from the Metropolis network of 40,000 UK-based doctors. We bridge the gap between expensive locum agencies and DIY solutions like Indeed and LinkedIn that distract your team.",
     },
     {
          faqQuestion: "How long have Metropolis been around?",
          faqAnswer: "Metropolis helps organization looking to hire doctors to easily connect to active candidates from the Metropolis network of 40,000 UK-based doctors. We bridge the gap between expensive locum agencies and DIY solutions like Indeed and LinkedIn that distract your team.",
     },
]


export const Home = () => {
     const onChange = (key) => {
          console.log(key);
     };

     const swiper1Ref = useRef();
     const swiper2Ref = useRef();
     useLayoutEffect(() => {
          swiper1Ref.current.controller.control = swiper2Ref.current;
          swiper2Ref.current.controller.control = swiper1Ref.current;
     }, []);
     return (
          <>
               {/* // _BEGIN > HERO < RIA // */}
               <section className="sector-hero">
                    <div className="mtp-container">
                         <div className="sector-hero-wrap">
                              <Row gutter={24}>
                                   <Col span={10}>
                                        <div className="hero-content-wrap">
                                             <h1 className="section-heading-xxl text-color-alpha fw-700">Your employer brand starts here.</h1>
                                             <p className="fw-400 text-color-bravo">Authentic reviews, rich storytelling and powerful insights, found only on Metropolis, help you attract top talent.</p>
                                             <Button className="CustomButton  mtp-button " type="prime" > Get Started</Button>
                                        </div>
                                   </Col>
                                   <Col span={14}>
                                        <div className="hero-image-wrap">
                                             <img src={heroImage} alt="hero" />
                                        </div>
                                   </Col>
                              </Row>
                         </div>
                    </div>
               </section>
               {/* // _END > HERO < RIA // */}


               {/* // _BEGIN > CHOOSE US  < RIA // */}
               <section className="choose-us ground-color-ashes">
                    <div className="mtp-container">
                         <div className="section-header-lg choose-us-header ">
                              <h3 className="section-header-lg-primary-heading text-color-alpha fw-700 h3">
                                   Why Choose Us?
                              </h3>
                              <p className="section-header-lg-secondary-text  text-color-bravo fw-400">
                                   Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                              </p>
                         </div>
                         <div className="choose-us-wrap">
                              <div className="choose-us-innerWrap">
                                   <div className="choose-us-image-background flex-center flex-center-auto-0">
                                        <div className="choose-us-image flex-center  flex-center-auto-0">
                                             {SVGicon.mtpIconHighQuality}
                                        </div>
                                   </div>
                                   <div className="choose-us-content">
                                        <h6 className="fw-600 text-color-alpha">High quality, active doctors</h6>
                                        <p className="fw-400 text-color-bravo">All Metropolis doctors are pre-screened, and are actively looking for work. They have opted into hearing about opportunities like yours.</p>
                                   </div>
                              </div>
                              <div className="choose-us-innerWrap">
                                   <div className="choose-us-image-background flex-center flex-center-auto-0">
                                        <div className="choose-us-image flex-center  flex-center-auto-0">
                                             {SVGicon.mtpIconCommissions}
                                        </div>
                                   </div>
                                   <div className="choose-us-content">
                                        <h6 className="fw-600 text-color-alpha">No ongoing commissions</h6>
                                        <p className="fw-400 text-color-bravo">We’re not a locum agency. You have a direct relationship with the doctor, giving you stability and continuity of care. And no commissions!</p>
                                   </div>
                              </div>
                              <div className="choose-us-innerWrap">
                                   <div className="choose-us-image-background flex-center flex-center-auto-0">
                                        <div className="choose-us-image flex-center  flex-center-auto-0">
                                             {SVGicon.mtpIconFastProcess}
                                        </div>
                                   </div>
                                   <div className="choose-us-content">
                                        <h6 className="fw-600 text-color-alpha">Simple, fast process</h6>
                                        <p className="fw-400 text-color-bravo">We’ve honed our recruitment process to give you rapid access to doctors without the hassle. No more wading through unsuitable CVs from Linkedin or Indeed!</p>
                                   </div>
                              </div>
                              <div className="choose-us-innerWrap">
                                   <div className="choose-us-image-background flex-center flex-center-auto-0">
                                        <div className="choose-us-image flex-center  flex-center-auto-0">
                                             {SVGicon.mtpIconHiringSupport}
                                        </div>
                                   </div>
                                   <div className="choose-us-content">
                                        <h6 className="fw-600 text-color-alpha">Hiring support</h6>
                                        <p className="fw-400 text-color-bravo">We give you tools to support through the hiring process: interview scheduling, candidate portal and compliance support.</p>
                                   </div>
                              </div>
                         </div>
                    </div>
               </section>
               {/* // _END > CHOOSE US < RIA // */}


               {/* // _BEGIN > FEATURE   < RIA // */}
               <section className="feature">
                    <div className="mtp-container">
                         <div className="feature-wrap">
                              <Row>
                                   <Col span={12}>
                                        <div className="feature-content-wrap mr-auto">
                                             <h3 className="fw-700 text-color-alpha">Strategy & Design</h3>
                                             <p className="fw-500 text-color-bravo">We'll speak to deeply understand your hiring requirements and
                                                  screening criteria for doctors.
                                                  We can scren by years of experience, exams, minimum availability and more.</p>

                                             <p className="fw-500 text-color-bravo">
                                                  We also collect key information about your business and your role such as clinical duties, rotas, pay & benefits.</p>
                                             <p className="fw-500 text-color-bravo">  Then, these details are written up into a 'Campaign' by Metropolis's team
                                                  of doctors.
                                             </p>
                                             <div className="learn-more-btn d-flex">
                                                  <Link className="learn-more-btn-link" to="/">Learn More </Link>

                                             </div>
                                        </div>
                                   </Col>
                                   <Col span={12}>
                                        <div className="feature-image-wrap">
                                             <img src={featureimgOne} alt="featureimgOne" />
                                        </div>
                                   </Col>
                              </Row>
                         </div>
                         <div className="feature-wrap">
                              <Row>
                                   <Col span={12}>
                                        <div className="feature-image-wrap">
                                             <img src={featureimgTwo} alt="featureimgTwo" />
                                        </div>
                                   </Col>
                                   <Col span={12}>
                                        <div className="feature-content-wrap ml-auto">
                                             <h3 className="fw-700 text-color-alpha">Run Campaign</h3>
                                             <p className="fw-500 text-color-bravo">We run a targeted Campaign, sharing details of your opportunity to suitable doctors in the Metropolis network, using our insights into the doctor mindset to best sell your roles.</p>
                                             <p className="fw-500 text-color-bravo"> This includes app-notification, emails, social media and with our network of partners.‍</p>
                                             <p className="fw-500 text-color-bravo"> We work with you to collect feedback from doctors, and can adjust your Campaign as needed.</p>
                                             <div className="learn-more-btn d-flex">
                                                  <Link className="learn-more-btn-link" to="/">Learn More </Link>
                                             </div>
                                        </div>
                                   </Col>
                              </Row>
                         </div>
                         <div className="feature-wrap">
                              <Row>
                                   <Col span={12}>
                                        <div className="feature-content-wrap mr-auto">
                                             <h3 className="fw-700 text-color-alpha">Process & Onboarding</h3>
                                             <p className="fw-500 text-color-bravo">
                                                  All candidates are personally screened by our team of recruiters and doctors against your criteria. No time-wasters!</p>
                                             <p className="fw-500 text-color-bravo">Suitable candidates are shared using our applicant tracking portal, so you can easily manage your pipeline of candidates.</p>
                                             <p className="fw-500 text-color-bravo"> We will support with interview scheduling, doctor liaison and collating doctor compliance documentation.</p>
                                             <div className="learn-more-btn d-flex">
                                                  <Link className="learn-more-btn-link" to="/">Learn More </Link>
                                             </div>
                                        </div>
                                   </Col>
                                   <Col span={12}>
                                        <div className="feature-image-wrap">
                                             <img src={featureimgThree} alt="featureimgThree" />
                                        </div>
                                   </Col>
                              </Row>
                         </div>
                    </div>
               </section>
               {/* // _END >  FEATURE  < RIA // */}


               {/* // _BEGIN > EMPLOYER REVIEW SLIDER   < RIA // */}
               <section className="employe-review-slider ground-color-ashes">
                    <div className="section-header-lg choose-us-header ">
                         <h3 className="section-header-lg-primary-heading text-color-alpha fw-700 h3">
                              What Other Employer Says
                         </h3>
                         <p className="section-header-lg-secondary-text  text-color-bravo fw-400">
                              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                         </p>
                    </div>
                    { /* swipper start */}
                    <div className="employe-review-swipper-slider">

                         { /* First swipper start */}
                         <div className="swiperOne-wrap">
                              <Swiper
                                   onSwiper={(swiper) => { swiper1Ref.current = swiper; }}
                                   spaceBetween={40}
                                   slidesPerView={3}
                                   loop={true}
                                   speed={800}
                                   autoplay={{ disableOnInteraction: true, }}
                                   navigation={false}
                                   modules={[Autoplay, Controller]}
                                   className="mySwiperOne"
                              >
                                   {ReviewTextOne.map((reviewItems, reviewIndexOne) => (
                                        <SwiperSlide key={reviewIndexOne}>
                                             <div className="employe-review-swipper-card">
                                                  <div className="employe-review-swipper-card-head">
                                                       <div className="employe-info-wrap">
                                                            <div className="employe-info-avatar-wrapper">
                                                                 <Avatar src={reviewItems.userAvatar} className="employe-info-left-img-wrap flex-center cover-image" />
                                                            </div>
                                                            <div className="employe-info-right-img-wrap">
                                                                 <p className="fw-600 text-color-alpha">{reviewItems.userName}</p>
                                                                 <span className="fw-500 text-color-bravo">{reviewItems.userPlace}</span>
                                                            </div>
                                                       </div>
                                                       <div className="rate-wrap">
                                                            <div className="star-playIcon flex-center flex-center-auto-0">
                                                                 {SVGicon.mtpIconStarFill}
                                                            </div>
                                                            <div className="star-playIcon flex-center flex-center-auto-0">
                                                                 {SVGicon.mtpIconStarFill}
                                                            </div>
                                                            <div className="star-playIcon flex-center flex-center-auto-0">
                                                                 {SVGicon.mtpIconStarFill}
                                                            </div>
                                                            <div className="star-playIcon flex-center flex-center-auto-0">
                                                                 {SVGicon.mtpIconStarFill}
                                                            </div>
                                                            <div className="star-playIcon flex-center flex-center-auto-0">
                                                                 {SVGicon.mtpIconStarempty}
                                                            </div>
                                                       </div>
                                                  </div>

                                                  <div className="employe-review-swipper-card-content ">
                                                       <span className="fw-500 ellipsis ellipsis-line-five">{reviewItems.userReview}</span>
                                                  </div>
                                             </div>
                                        </SwiperSlide>
                                   ))}

                              </Swiper>
                         </div>
                         { /* First swipper end */}

                         { /* second swipper start */}
                         <div className="swiperTwo-wrap">
                              <Swiper
                                   onSwiper={(swiper) => {
                                        swiper2Ref.current = swiper;
                                   }}
                                   spaceBetween={40}
                                   slidesPerView={3.3}
                                   loop={true}
                                   speed={800}
                                   autoplay={{
                                        disableOnInteraction: true,
                                   }}

                                   navigation={false}
                                   modules={[Autoplay, Controller]}
                                   className="mySwiperTwo"
                              >
                                   {ReviewTextTwo.map((reviewItems, reviewIndexTwo) => (
                                        <SwiperSlide key={reviewIndexTwo}>
                                             <div className="employe-review-swipper-card">
                                                  <div className="employe-review-swipper-card-head">
                                                       <div className="employe-info-wrap">
                                                            <div className="employe-info-avatar-wrapper">
                                                                 {reviewItems.userAvatar !== "" ? (<Avatar src={reviewItems.userAvatar} className="employe-info-left-img-wrap flex-center cover-image" />) :
                                                                      (<Avatar className="employe-info-left-img-wrap flex-center cover-image">{reviewItems.userInitial}</Avatar>)}
                                                            </div>
                                                            <div className="employe-info-right-img-wrap">
                                                                 <p className="fw-600 text-color-alpha">{reviewItems.userName}</p>
                                                                 <span className="fw-500 text-color-bravo">{reviewItems.userPlace}</span>
                                                            </div>
                                                       </div>
                                                       <div className="rate-wrap">
                                                            <div className="star-playIcon flex-center flex-center-auto-0">
                                                                 {SVGicon.mtpIconStarFill}
                                                            </div>
                                                            <div className="star-playIcon flex-center flex-center-auto-0">
                                                                 {SVGicon.mtpIconStarFill}
                                                            </div>
                                                            <div className="star-playIcon flex-center flex-center-auto-0">
                                                                 {SVGicon.mtpIconStarFill}
                                                            </div>
                                                            <div className="star-playIcon flex-center flex-center-auto-0">
                                                                 {SVGicon.mtpIconStarFill}
                                                            </div>
                                                            <div className="star-playIcon flex-center flex-center-auto-0">
                                                                 {SVGicon.mtpIconStarempty}
                                                            </div>
                                                       </div>
                                                  </div>
                                                  <div className="employe-review-swipper-card-content ">
                                                       <span className="fw-500 ellipsis ellipsis-line-five">{reviewItems.userReview}</span>
                                                  </div>
                                             </div>
                                        </SwiperSlide>
                                   ))}
                              </Swiper>
                         </div>
                         { /* second swipper end */}


                    </div>
                    { /* swipper end */}

               </section>
               {/* // _END > EMPLOYER REVIEW SLIDER   < RIA // */}


               {/* // _BEGIN >ORGANIZATION BLOG SECTION  < RIA // */}
               <section className="organization-blog-section">
                    <div className="mtp-container">
                         <div className="section-header-lg choose-us-header ">
                              <h3 className="section-header-lg-primary-heading text-color-alpha fw-700 h3">
                                   Getting Started With Metropolis
                              </h3>
                              <p className="section-header-lg-secondary-text  text-color-bravo fw-400">
                                   Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                              </p>
                         </div>

                         <div className="organization-blog-started">
                              <Row gutter={24}>
                                   {OrganizationBlog.map((organizationblogItem, blogIndex) => (
                                        <Col span={8} key={blogIndex}>
                                             <div className="organization-blog-wrap">
                                                  <div className="organization-blog-image-wrap overflow-hidden">
                                                       <img src={organizationblogItem.organizationBlogImage} alt="" />
                                                  </div>
                                                  <div className="organization-blog-content-wrap">
                                                       <h6 className="fw-600 text-color-alpha">{organizationblogItem.organizationBlogTitle}</h6>
                                                       <p className="fw-400 text-color-bravo">{organizationblogItem.organizationBlogText}</p>
                                                       <Link to="" className="view-more-link">View More</Link>
                                                  </div>
                                             </div>
                                        </Col>
                                   ))}
                              </Row>
                         </div>
                    </div>
               </section>
               {/* // _END > ORGANIZATION BLOG SECTION < RIA // */}


               {/* // _BEGIN > HIRING DOCTORS  < RIA // */}
               <section className="start-hiring-doctors">
                    <div className="mtp-container">
                         <div className="hiring-doctors-wrap">
                              <div className="hiring-doctors-background">
                              </div>
                              <div className="hiring-doctors-content-form-wrap">
                                   <h4 className="fw-700 text-color-white">Start hiring doctors today</h4>
                                   <p className="fw-400 text-color-white">Fill our your details below and one one of our team will contact you</p>
                                   <div className="hiring-doctors-input-wrap">

                                        <Form
                                             layout="inline"
                                             autoComplete="off"
                                             className="mtp-form"
                                             validateMessages={validateMessages}
                                        >
                                             <Form.Item name="email" rules={[{ type: 'email' }]}>
                                                  <Input className="mtp-form-control " placeholder="Enter your email" />
                                             </Form.Item>
                                             <Form.Item>

                                                  <Button className="CustomButton mtp-button" type="prime-outlined" >   Sign Up </Button>
                                             </Form.Item>
                                        </Form>
                                   </div>
                              </div>
                              <div className="hiring-doctors-image-wrap">
                                   <img src={doctorImage} alt="doctorImage" />
                              </div>
                         </div>
                    </div>
               </section>
               {/* // _END > HIRING DOCTORS  < RIA // */}


               {/* // _BEGIN > WORKED WITH CLIENTS  < RIA // */}
               <section className="work-with-client">
                    <div className="section-header-lg ">
                         <h3 className="section-header-lg-primary-heading text-color-alpha fw-700 h3">
                              Clients We've Worked With
                         </h3>
                    </div>
                    <div className="work-with-client-slider">
                         <Swiper
                              slidesPerView={7}
                              spaceBetween={30}
                              loop={true}
                              speed={800}
                              autoplay={{
                                   disableOnInteraction: false,
                              }}
                              modules={[Autoplay]}
                              className="ClientSwiper"
                         >
                              <SwiperSlide>
                                   <div className="clientLogo flex-center flex-center-auto-0">
                                        <img src={clientOne} alt="clientOne" />
                                   </div>
                              </SwiperSlide>
                              <SwiperSlide>
                                   <div className="clientLogo flex-center flex-center-auto-0">
                                        <img src={clientTwo} alt="clientTwo" />
                                   </div>
                              </SwiperSlide>
                              <SwiperSlide>
                                   <div className="clientLogo flex-center flex-center-auto-0">
                                        <img src={clientThree} alt="clientThree" />
                                   </div>
                              </SwiperSlide>
                              <SwiperSlide>
                                   <div className="clientLogo flex-center flex-center-auto-0">
                                        <img src={clientFour} alt="clientFour" />
                                   </div>
                              </SwiperSlide>
                              <SwiperSlide>
                                   <div className="clientLogo flex-center flex-center-auto-0">
                                        <img src={clientFive} alt="clientFive" />
                                   </div>
                              </SwiperSlide>
                              <SwiperSlide>
                                   <div className="clientLogo flex-center flex-center-auto-0">
                                        <img src={clientSix} alt="clientSix" />
                                   </div>
                              </SwiperSlide>
                              <SwiperSlide>
                                   <div className="clientLogo flex-center flex-center-auto-0">
                                        <img src={clientSeven} alt="clientSeven" />
                                   </div>
                              </SwiperSlide>

                         </Swiper>
                    </div>
               </section>
               {/* // _END > WORKED WITH CLIENTS  < RIA // */}


               {/* // _BEGIN > FAQ START  < RIA // */}
               <section className="frequently-asked-questions ground-color-ashes">
                    <div className="section-header-lg choose-us-header ">
                         <h3 className="section-header-lg-primary-heading text-color-alpha fw-700 h3">
                              Frequently Asked Questions
                         </h3>
                         <p className="section-header-lg-secondary-text  text-color-bravo fw-400">
                              Have questions? We are here to help.
                         </p>
                    </div>
                    <div className="mtp-container">
                         <div className="mtp-accordion-item-wrapper  mtp-home-accordion">
                              <Collapse
                                   accordion
                                   defaultActiveKey={["1"]}
                                   onChange={onChange}
                                   expandIcon={({ isActive }) =>
                                        isActive ? (
                                             <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                  <path
                                                       d="M2.70944 9.17506C2.60063 9.17372 2.49262 9.19392 2.39165 9.2345C2.2902 9.27526 2.19787 9.33579 2.12001 9.41255C2.04216 9.4893 1.98034 9.58077 1.93814 9.68163C1.89595 9.78249 1.87422 9.89073 1.87422 10.0001C1.87422 10.1094 1.89595 10.2176 1.93814 10.3185C1.98034 10.4194 2.04216 10.5108 2.12001 10.5876C2.19787 10.6643 2.2902 10.7249 2.39165 10.7656C2.49262 10.8062 2.60063 10.8264 2.70943 10.8251H17.2901C17.3989 10.8264 17.507 10.8062 17.6079 10.7656C17.7094 10.7249 17.8017 10.6643 17.8796 10.5876C17.9574 10.5108 18.0192 10.4194 18.0614 10.3185C18.1036 10.2176 18.1254 10.1094 18.1254 10.0001C18.1254 9.89073 18.1036 9.78249 18.0614 9.68163C18.0192 9.58077 17.9574 9.4893 17.8796 9.41255C17.8017 9.33579 17.7094 9.27526 17.6079 9.2345C17.5069 9.19392 17.3989 9.17372 17.2901 9.17506H2.70944Z"
                                                       fill="currentColor"
                                                       stroke="black"
                                                       strokeWidth="0.4"
                                                  />
                                             </svg>
                                        )
                                             : (
                                                  <svg
                                                       width="20"
                                                       height="20"
                                                       viewBox="0 0 20 20"
                                                       fill="none"
                                                       xmlns="http://www.w3.org/2000/svg"
                                                  >
                                                       <path
                                                            d="M9.4077 2.12468C9.25579 2.28121 9.17206 2.49152 9.17479 2.70959V9.17491H2.70943C2.60063 9.17357 2.49262 9.19377 2.39165 9.23435L2.46622 9.41993L2.39165 9.23435C2.2902 9.27512 2.19787 9.33564 2.12001 9.4124C2.04216 9.48916 1.98034 9.58062 1.93814 9.68148C1.89595 9.78234 1.87422 9.89058 1.87422 9.99991C1.87422 10.1092 1.89595 10.2175 1.93814 10.3183C1.98034 10.4192 2.04216 10.5107 2.12001 10.5874C2.19787 10.6642 2.2902 10.7247 2.39165 10.7655C2.49262 10.8061 2.60063 10.8263 2.70943 10.8249H9.17479V17.2903C9.17345 17.3991 9.19365 17.5071 9.23422 17.6081L9.4198 17.5335L9.23422 17.6081C9.27499 17.7095 9.33551 17.8018 9.41227 17.8797C9.48903 17.9575 9.5805 18.0194 9.68136 18.0616C9.78222 18.1038 9.89046 18.1255 9.99979 18.1255C10.1091 18.1255 10.2174 18.1038 10.3182 18.0616C10.4191 18.0194 10.5105 17.9575 10.5873 17.8797C10.6641 17.8018 10.7246 17.7095 10.7654 17.6081C10.8059 17.5071 10.8261 17.3991 10.8248 17.2903V10.8249H17.2901C17.3989 10.8263 17.5069 10.8061 17.6079 10.7655C17.7094 10.7247 17.8017 10.6642 17.8796 10.5874C17.9574 10.5107 18.0192 10.4192 18.0614 10.3183C18.1036 10.2175 18.1254 10.1092 18.1254 9.99991C18.1254 9.89058 18.1036 9.78234 18.0614 9.68148C18.0192 9.58062 17.9574 9.48915 17.8796 9.4124C17.8017 9.33564 17.7094 9.27512 17.6079 9.23435L17.5334 9.41993L17.6079 9.23435C17.507 9.19377 17.3989 9.17357 17.2901 9.17491H10.8248V2.70962C10.8262 2.59971 10.8056 2.49062 10.7642 2.38877L10.5789 2.46404L10.7642 2.38877C10.7226 2.28646 10.661 2.19354 10.5828 2.1155L10.5828 2.1155C10.5047 2.03746 10.4117 1.97591 10.3093 1.93448C10.207 1.89305 10.0973 1.87259 9.9869 1.87432C9.76829 1.87773 9.55997 1.96778 9.4077 2.12468Z"
                                                            fill="currentColor"
                                                            stroke="#393E40"
                                                            strokeWidth="0.4"
                                                       />
                                                  </svg>
                                             )
                                   }
                              >
                                   {HomeFAQ.map((faqHomeItems, faqHomeIndex) => (
                                        <Panel key={` faqCollapse${faqHomeIndex + 1}`} header={faqHomeItems.faqQuestion} arrow="right">
                                             <p>{faqHomeItems.faqAnswer}</p>
                                        </Panel>
                                   ))}
                              </Collapse>
                         </div>
                    </div>
               </section>
               {/* // _END > FAQ END  < RIA // */}
          </>
     )
}

